import {Component, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {Account, IUser, User} from '../../../core/user';
import {AccountService, EventManager, UserService} from '../../../core';
import {ActivatedRoute, Router} from '@angular/router';
import {ITEMS_PER_PAGE} from '../../../shared/constants';
import { Subscription } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import {MembersUpdateComponent} from '../members-update/members-update.component';
import {MemberService} from '../member.service';

@Component({
  selector: 'app-members-list',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss']
})

export class MembersComponent implements OnInit, OnDestroy {
  currentAccount: Account | null = null;
  users: User[] | null = null;
  userListSubscriptions?: Subscription[] = [];
  totalItems = 0;
  size = ITEMS_PER_PAGE;
  page!: number;
  predicate!: string;
  previousPage!: number;
  ascending!: boolean;
  search: any;
  queryParams: any;

  constructor(
    private memberService: MemberService,
    private accountService: AccountService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public modalService: NzModalService,
    private eventManager: EventManager,
    private userService: UserService
  ) {
    this.userListSubscriptions.push(this.activatedRoute.data.subscribe(data => {
      this.page = data.pagingParams.page;
      this.previousPage = data.pagingParams.page;
      this.ascending = data.pagingParams.ascending;
      this.predicate = data.pagingParams.predicate;
    }));
  }

  ngOnInit(): void {
    this.queryParams = {
      page: this.page - 1,
      size: this.size,
      sort: this.sort()
    };
    this.activatedRoute.data
      .pipe(
        flatMap(
          () => this.accountService.identity(),
          (data, account) => {
            this.currentAccount = account;
            this.loadAll(this.queryParams);
            this.userListSubscriptions.push(this.eventManager.subscribe('userListModification', () => this.loadAll(this.queryParams)));
          }
        )
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.userListSubscriptions.length > 0) {
      this.eventManager.destroys(this.userListSubscriptions);
    }
  }

  setActive(user: User, isActivated: boolean): void {
    this.userService.update({ ...user, activated: isActivated }).subscribe(() => this.loadAll(this.queryParams));
  }

  trackIdentity(index: number, item: User): any {
    return item.id;
  }

  private loadAll(req: any): void {
    this.memberService
      .query(req)
      .subscribe((res: HttpResponse<User[]>) => this.onSuccess(res.body, res.headers));
  }

  private sort(): string[] {
    const result = [this.predicate + ',' + (this.ascending ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  private onSuccess(users: User[] | null, headers: HttpHeaders): void {
    this.totalItems = Number(headers.get('X-Total-Count'));
    this.users = users;
  }

  buildUserModal(user?: IUser): void {
    let title = 'Add User';
    if (user) {
      title = 'Update User';
    }
    const modal = this.modalService.create({
      nzTitle: title,
      nzWidth: '650px',
      nzStyle: { top: '20px' },
      nzContent: MembersUpdateComponent,
      nzData: { user }
    });
  }

  confirmDelete(username: string) {
    this.userService.deactivate(username).subscribe(rs => {
      this.loadAll(this.queryParams);
    });
  }

  cancelDelete() {
    // todo
  }

  loadPage(event: number) {
    const page = event;
    this.page = page;
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.queryParams = {
        page: this.page - 1,
        size: this.size,
        sort: this.sort()
      };
      this.loadAll(this.queryParams);
    }
  }
}
